module.exports = __webpack_public_path__ + "79590b58edbf0d92feaf0233a4136206.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/support-widget.woff
// module id = 4DN6
// module chunks = 0